import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../service/caller';
import { Modal, Button, Form, Row, Col, Alert } from 'react-bootstrap';

const ConsultationDetails = () => {
    const { consultationId } = useParams();
    const [consultationData, setConsultationData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [medicalHistoryData, setMedicalHistoryData] = useState(null);
    const [analyses, setAnalyses] = useState([]);
    const [newAnalysis, setNewAnalysis] = useState({ Analysename: '', Analyseresult: '', fileresult: '' });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        const fetchConsultationDetails = async () => {
            try {
                const response = await api.get(`api/consultations/${consultationId}`);
                setConsultationData(response.data);
                
                // Récupérer le MedicalHistory associé si disponible
                if (response.data.medicalHistory) {
                    const medHistoryResponse = await api.get(`api/medical_history/${consultationId}`);
                    setMedicalHistoryData(medHistoryResponse.data);
                    setAnalyses(medHistoryResponse.data.Analysesresults || []);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des détails:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchConsultationDetails();
    }, [consultationId]);

    // Extraire les clés ayant une valeur `true`
    const extractTrueCategories = (analysis) => {
        const result = [];

        // Fonction récursive pour traverser les objets imbriqués
        const traverse = (obj, parentCategory) => {
            for (const [category, value] of Object.entries(obj)) {
                if (typeof value === 'object' && value !== null) {
                    traverse(value, category);
                } else if (value === true) {
                    result.push({ parentCategory, subCategory: category });
                }
            }
        };

        for (const [category, details] of Object.entries(analysis)) {
            traverse(details, category);
        }

        return result;
    };

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setError('');
        setSuccess('');
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setMedicalHistoryData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDeliveryDetailsChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        
        setMedicalHistoryData(prev => ({
            ...prev,
            deliveryDetails: {
                ...prev.deliveryDetails,
                [name]: val
            }
        }));
    };

    const handleNewAnalysisChange = (e) => {
        const { name, value } = e.target;
        setNewAnalysis(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const addAnalysis = () => {
        if (!newAnalysis.Analysename || !newAnalysis.Analyseresult) {
            setError('Le nom et le résultat de l\'analyse sont requis');
            return;
        }
        
        setAnalyses(prev => [...prev, { ...newAnalysis, _id: `temp-${Date.now()}` }]);
        setNewAnalysis({ Analysename: '', Analyseresult: '', fileresult: '' });
        setError('');
    };

    const removeAnalysis = (index) => {
        setAnalyses(prev => prev.filter((_, i) => i !== index));
    };

    const saveMedicalHistory = async () => {
        try {
            setError('');
            setSuccess('');
            
            // Préparer les données à envoyer
            const updatedData = {
                ...medicalHistoryData,
                Analysesresults: analyses
            };
            
            // Si c'est un nouveau dossier médical
            // if (!medicalHistoryData._id) {
            //     updatedData.ConsultationId = consultationId;
            //     updatedData.patientId = consultationData.patientId._id;
                
            //     const response = await api.post('api/medical-history', updatedData);
            //     setMedicalHistoryData(response.data);
            //     setSuccess('Dossier médical créé avec succès');
            // } else {
                // Mise à jour d'un dossier existant
                const response = await api.put(`api/medical_history/${medicalHistoryData._id}`, updatedData);
                setMedicalHistoryData(response.data);
                setSuccess('Dossier médical mis à jour avec succès');
            // }
        } catch (error) {
            console.error('Erreur lors de la sauvegarde:', error);
            setError('Erreur lors de la sauvegarde du dossier médical');
        }
    };

    if (loading) {
        return <p>Chargement...</p>;
    }

    const { medicalHistory, allergies, diagnosis, prescriptions, followUp, clinical_exam, laboratoryAnalysis } = consultationData;

    return (
        <div className="position-relative">
            <div className="bg-white p-5">
                <div>
                    <button className="btn btn-prim rounded-pill py-2 px-4" style={{ color: '#0056B3', border: '1.5px solid #0056B3' }}>
                        <i className="bi bi-arrow-left me-2"></i>Retour
                    </button>
                </div>

                {/* Détails du patient */}
                <div className="text-white mt-3 p-3 row" style={{ background: '#1A5D1A', borderRadius: '15px' }}>
                    <div className="col-12 col-md-5 mx-auto mb-3">
                        <p>Name :</p>
                        <br />
                        <h3>{consultationData.patientId.firstname || 'Nom non disponible'}</h3>
                    </div>
                    <div className="col-md-3"></div>
                    <div className="col-12 col-md-4 mx-auto mb-3">
                        <p className="text-center text-md-end">Appointment of</p>
                        <br />
                        <h3 className="text-center text-md-end">{new Date(consultationData.createdAt).toLocaleDateString()}</h3>
                        <p className="text-center text-md-end">{new Date(consultationData.createdAt).toLocaleTimeString()}</p>
                    </div>
                </div>

                {/* Vital signs */}
                <div className="mt-3 p-3" style={{ background: '#28A7452B', borderRadius: '10px' }}>
                    <strong>Vital signs</strong>
                </div>
                <div className="mt-3 ms-3">
                    <ul>
                        <li>Body Temperature : <strong style={{ color: '#EF3826' }}>35.7°C</strong></li>
                        <li>Blood pressure : <strong>120/90 mmHg</strong></li>
                    </ul>
                    <p>Note : <strong>Lorem Ipsum is simply dummy text of the printing and typesetting industry...</strong></p>
                </div>

                {/* General questions */}
                <div className="mt-3 p-3" style={{ background: '#28A7452B', borderRadius: '10px' }}>
                    <strong>General questions</strong>
                </div>
                <div className="mt-3 ms-3">
                    {consultationData.doctorsquestion && consultationData.doctorsquestion.map((q, index) => (
                        <div key={index}>
                            <div className="row mt-3">
                                <div className="col-1 mx-auto">
                                    <strong>Q :</strong>
                                </div>
                                <div className="col-11 mx-auto">
                                    <p>{q.label}</p>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-1 mx-auto align-self-center">
                                    <strong>R :</strong>
                                </div>
                                <div className="col-11 mx-auto">
                                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                        <li>{q.content}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Maladies / Allergies */}
                <div className="mt-3 p-3" style={{ background: '#28A7452B', borderRadius: '10px' }}>
                    <strong>Maladies / Allergies</strong>
                </div>
                <div className="mt-3 ms-3">
                    {allergies && allergies.map((allergy, index) => (
                        <p key={index}>{allergy.label} : <strong>{allergy.response || 'Non renseigné'}</strong></p>
                    ))}
                </div>

                {/* Affichage des analyses de laboratoire */}
                <div className="mt-3 p-3" style={{ background: '#28A7452B', borderRadius: '10px' }}>
                    <strong>Laboratory Analysis</strong>
                </div>
                <div className="mt-3 ms-3">
                    <ul>
                        {laboratoryAnalysis.map((analysis, index) => {
                            const trueCategories = extractTrueCategories(analysis);

                            return (
                                <div key={index}>
                                    {trueCategories.map((item, idx) => (
                                        <div key={idx}>
                                            <p><strong>{item.parentCategory}:</strong></p>
                                            <ul>
                                                <li>{item.subCategory}</li>
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            );
                        })}
                    </ul>
                </div>

                {/* Clinical Examinations */}
                <div className="mt-3 p-3" style={{ background: '#28A7452B', borderRadius: '10px' }}>
                    <strong>Clinical examinations</strong>
                </div>
                <div className="mt-3">
                    {clinical_exam && clinical_exam.map((exam, index) => (
                        <div key={index} className="row mt-3 ms-3">
                            <div className="col-3 mx-auto align-self-center">
                                <strong>{exam.label}:</strong>
                            </div>
                            <div className="col-9 mx-auto">
                                <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                    <li>{exam.content}</li>
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Diagnosis */}
                <div className="mt-3 p-3" style={{ background: '#28A7452B', borderRadius: '10px' }}>
                    <strong>Diagnosis</strong>
                </div>
                <div className="mt-3 ms-3">
                    {diagnosis && diagnosis.map((diag, index) => (
                        <p key={index}>
                            <strong style={{ textDecoration: 'underline' }}>{diag.type === 'doctorDiagnosis' ? 'Doctor Diagnosis' : 'AI Diagnosis'}</strong>
                            <br />
                            {diag.content}
                        </p>
                    ))}
                </div>

                {/* Prescriptions */}
                <div className="mt-3 p-3" style={{ background: '#28A7452B', borderRadius: '10px' }}>
                    <strong>Medical prescriptions</strong>
                </div>
                <div className="mt-3 ms-3">
                    {prescriptions && prescriptions.map((pres, index) => (
                        <div key={index} className="mt-3 ms-3" style={{ borderLeft: '1px solid #28A745' }}>
                            <div className="d-flex ms-2">
                                <div><strong>Name :</strong></div>
                                <div className="ms-2">{pres.name}</div>
                            </div>
                            <div className="d-flex ms-2">
                                <div><strong>Nbr de boites :</strong></div>
                                <div className="ms-2">{pres.boxes}</div>
                            </div>
                            <div className="d-flex ms-2">
                                <div className="align-self-center"><strong>Prises :</strong></div>
                                <div>
                                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                        <li>{pres.dosage}</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="d-flex ms-2 mt-3">
                                <div><strong>Durée  :</strong></div>
                                <div className="ms-2">{pres.duration}</div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Follow up */}
                <div className="d-flex ms-2 mt-4" >
                    <div><strong style={{ color: '#269226' }}>Follow up :</strong></div>
                    <div className="ms-3">
                        <p>{new Date(followUp).toLocaleDateString()}</p>
                    </div>
                </div>

                <div className="mt-2 d-flex justify-content-end">
                    <button type="button" className="btn btn-prim text-white fw-bold px-4 py-2" style={{ background: '#1A5D1A' }}>
                        Export to pdf <i className="bi bi-arrow-down-square ms-2 fw-bold"></i>
                    </button>
                    <button type="button" className="btn btn-primary text-white fw-bold px-4 py-2 mx-2" onClick={handleOpenModal}>
                        Ajouter notes <i className="bi bi-arrow-down-square ms-2 fw-bold"></i>
                    </button>
                </div>
            </div>

            {/* Modal pour modifier le MedicalHistory */}
            <Modal show={showModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton style={{ background: '#28A7452B' }}>
                    <Modal.Title>Modifier le dossier médical</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}
                    {success && <Alert variant="success">{success}</Alert>}
                    
                    {medicalHistoryData && (
                        <Form>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Statut de santé</Form.Label>
                                        <Form.Select 
                                            name="healthStatus" 
                                            value={medicalHistoryData.healthStatus || 'Non critique'} 
                                            onChange={handleInputChange}
                                        >
                                            <option value="Critique">Critique</option>
                                            <option value="Non critique">Non critique</option>
                                            <option value="Stable">Stable</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Statut du patient</Form.Label>
                                        <Form.Select 
                                            name="patientStatus" 
                                            value={medicalHistoryData.patientStatus || 'En traitement'} 
                                            onChange={handleInputChange}
                                        >
                                            <option value="Vivant">Vivant</option>
                                            <option value="Décédé">Décédé</option>
                                            <option value="Guéri">Guéri</option>
                                            <option value="En traitement">En traitement</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="mt-4 mb-3">
                                <h5>Détails de l'accouchement</h5>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Check 
                                                type="checkbox" 
                                                label="A accouché" 
                                                name="hadDelivery"
                                                checked={medicalHistoryData.deliveryDetails?.hadDelivery || false}
                                                onChange={handleDeliveryDetailsChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {medicalHistoryData.deliveryDetails?.hadDelivery && (
                                        <>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Date d'accouchement</Form.Label>
                                                    <Form.Control 
                                                        type="date" 
                                                        name="deliveryDate"
                                                        value={medicalHistoryData.deliveryDetails?.deliveryDate ? new Date(medicalHistoryData.deliveryDetails.deliveryDate).toISOString().split('T')[0] : ''}
                                                        onChange={handleDeliveryDetailsChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Type d'accouchement</Form.Label>
                                                    <Form.Select 
                                                        name="deliveryType"
                                                        value={medicalHistoryData.deliveryDetails?.deliveryType || 'Autre'}
                                                        onChange={handleDeliveryDetailsChange}
                                                    >
                                                        <option value="Césarienne">Césarienne</option>
                                                        <option value="Vaginale">Vaginale</option>
                                                        <option value="Autre">Autre</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </>
                                    )}
                                </Row>
                            </div>

                            <div className="mt-4 mb-3">
                                <h5>Résultats d'analyses</h5>
                                <div className="mb-3">
                                    {analyses.map((analysis, index) => (
                                        <div key={index} className="card p-3 mb-2">
                                            <div className="d-flex justify-content-between">
                                                <h6>{analysis.Analysename}</h6>
                                                <Button 
                                                    variant="danger" 
                                                    size="sm"
                                                    onClick={() => removeAnalysis(index)}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </Button>
                                            </div>
                                            <p><strong>Résultat:</strong> {analysis.Analyseresult}</p>
                                            {analysis.fileresult && <p><strong>Fichier:</strong> {analysis.fileresult}</p>}
                                        </div>
                                    ))}
                                </div>
                                
                                <div className="card p-3">
                                    <h6>Ajouter une analyse</h6>
                                    <Row>
                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nom de l'analyse</Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="Analysename"
                                                    value={newAnalysis.Analysename}
                                                    onChange={handleNewAnalysisChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Résultat</Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="Analyseresult"
                                                    value={newAnalysis.Analyseresult}
                                                    onChange={handleNewAnalysisChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Fichier ou URL</Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="fileresult"
                                                    value={newAnalysis.fileresult}
                                                    onChange={handleNewAnalysisChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <div className="text-end">
                                        <Button 
                                            variant="success" 
                                            size="sm"
                                            onClick={addAnalysis}
                                        >
                                            Ajouter cette analyse
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            
                            <Form.Group className="mb-3">
                                <Form.Label>Date de consultation</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="consultationDate"
                                    value={medicalHistoryData.consultationDate ? new Date(medicalHistoryData.consultationDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]}
                                    onChange={handleInputChange}
                                />
                            </Form.Group>
                        </Form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Fermer
                    </Button>
                    <Button variant="primary" onClick={saveMedicalHistory} style={{ background: '#1A5D1A', borderColor: '#1A5D1A' }}>
                        Enregistrer
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ConsultationDetails;